import {createAsyncThunk} from "@reduxjs/toolkit";
import {iStateMessage} from "@/customTypes/GenericReduxTypes";


import {iGenericResponse} from "@/customTypes/CommonServiceTypes";
import {curryGetThunkName} from "@/projectUtils/ReduxUtil";
import {httpStatusCodes} from "@/customTypes/NetworkTypes";
import { wholesalerService } from "@/services/api/cresivoxServer";


import { REDUCER_NAME, iKYCApproved, iWholesalerDTO, iconnectWithWholesaler} from './Types';
import { iProductDetails } from "../product/Types";
const curriedGetThunkName = curryGetThunkName(REDUCER_NAME);


export const createWholesaler = createAsyncThunk<
iGenericResponse<any | null> | null,
iWholesalerDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("createWholesaler"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (payload, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.createWholesaler(payload);
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_CREATED: {
					if (data && data.data) {
						return {
							data: {
								orders: data.data?.order,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateWholesaler = createAsyncThunk<
iGenericResponse<any | null> | null,
iWholesalerDTO,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateWholesaler"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (data, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.updateWholesaler(data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const getWholesalerById = createAsyncThunk<
iGenericResponse<any | null> | null,
void,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getWholesalerById"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.getWholesalerById();
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								Wholesaler: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const getWholesalerList = createAsyncThunk<
  iGenericResponse<any | null> | null,
{filter?:string, search:string},
  {
	  rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("WholesalerList"),
  // @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
  async ({filter,search}, {rejectWithValue}) => {
	  try {
		 
		  const response = await wholesalerService.getAllWholesaler(search, filter);
		  if (response) {
			  const {httpStatusCode, data, message} = response;

			  switch (httpStatusCode) {
				  case httpStatusCodes.SUCCESS_OK: {
					  if (data && data.data) {
						const sortedData = [...data.data].sort((a, b) => {
							return new Date(b.created_at).getTime() - new Date(a.created_at).getTime();
						  });
						  return {
							data:{
							  httpStatusCode,
							  data: sortedData,
							  message,
							}
						  };
					  } else {
						  return rejectWithValue({
							  httpStatusCode,
							  message,
						  });
					  }
				  }
				  default: {
					  return rejectWithValue({
						  httpStatusCode,
						  message,
					  });
				  }
			  }
		  } else {
			  return rejectWithValue({
				  message: "No response received",
			  });
		  }
	  } catch (error) {
		  return rejectWithValue({
			  message: "Something went wrong",
		  });
	  }
  },
);



export const deleteWholesaler = createAsyncThunk<
iGenericResponse<any | null> | null,
{WholesalerId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("deleteWholesaler"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({WholesalerId}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.deleteWholesaler(WholesalerId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							
								data: data.data,
								message,
							
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const updateWholesalerForResaller = createAsyncThunk<
iGenericResponse<any | null> | null,
{wholesalerId:string, data:iKYCApproved},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateWholesalerForResaller"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({wholesalerId,data}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.updateWholesalerForResaller(wholesalerId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateWholesalerDucmentStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{wholesalerId:string, data:iKYCApproved},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateWholesalerDucmentStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({wholesalerId,data}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.updateWholesalerDucmentStatus(wholesalerId,data);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const connectRequestWithWholesaler = createAsyncThunk<
iGenericResponse<any | null> | null,
{WholesalerId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("connectWithWholesalers"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({WholesalerId}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.connectRequestWithWholesaler(WholesalerId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const updateApprovalStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{connectionId:string, isApproved?: boolean,status?:boolean},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("updateApprovalStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async ({connectionId,isApproved,status}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.updateApprovalStatus(connectionId,isApproved,status);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const getAllConnectionRequest = createAsyncThunk<
  iGenericResponse<any | null> | null,
  { status: string },
  {
    rejectValue: iStateMessage;
  }
>(
  curriedGetThunkName("getAllConnectionRequest"),
  // @ts-expect-error
  async ({ status }, { rejectWithValue }) => {
    try {
      const response = await wholesalerService.getAllConnectionRequest(status);
      if (response) {
        const { httpStatusCode, data, message } = response;

        switch (httpStatusCode) {
          case httpStatusCodes.SUCCESS_OK: {
            if (data && data.data) {
              // ✅ Sort by created_at DESC (newest first)
              const sortedData = [...data.data].sort((a, b) => {
                return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
              });
// console.log("111111111111111",sortedData);
              return {
                data: {
                  data: sortedData,
                  message,
                },
              };
            } else {
              return rejectWithValue({
                httpStatusCode,
                message,
              });
            }
          }
          default: {
            return rejectWithValue({
              httpStatusCode,
              message,
            });
          }
        }
      } else {
        return rejectWithValue({
          message: "No response received",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Something went wrong",
      });
    }
  }
);

// bulk import wholesaller product for resaler
export const importWholesalerProductForReseller = createAsyncThunk<
  iGenericResponse<any> | null,
  { wholesalerId: string; increaseprice: string; resellerId: string },
  { rejectValue: iStateMessage }
>(
  curriedGetThunkName("importWholesalerProductForReseller"),
  // @ts-expect-error
  async ({ wholesalerId, increaseprice, resellerId }, { rejectWithValue }) => {
    try {
      const response = await wholesalerService.importWholesalerBulkProduct(
        wholesalerId,
        { increaseprice, resellerId } // ✅ pass both args
      );

      if (response?.httpStatusCode === httpStatusCodes.SUCCESS_OK) {
        return {
          data: {
            data: response.data,
            message: response.message,
          },
        };
      } else {
        return rejectWithValue({
          httpStatusCode: response?.httpStatusCode || 500,
          message: response?.message || "Something went wrong",
        });
      }
    } catch (error) {
      return rejectWithValue({
        message: "Unexpected error occurred",
      });
    }
  }
);



export const getAllWholesalerProductList = createAsyncThunk<
iGenericResponse<any | null> | null,
{wholesalerId:string , page:number , limit:number , search?:string , title?:string , brand?:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getAllWholesalerProductList"),
// @ts-expect-error: Type mismatch between expected types
async ({wholesalerId,page,limit,search , title , brand }, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.getAllWholesalerProductList(wholesalerId,page,limit ,search ,title , brand );
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);


export const importWholesalerProduct = createAsyncThunk<
iGenericResponse<any | null> | null,
{wholesalerId:string,payload:iProductDetails},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("importWholesalerProduct"),
// @ts-expect-error: Type mismatch between expected types
async ({wholesalerId,payload}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.importWholesalerProduct(wholesalerId,payload);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);

export const getConnectionStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
void,
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("getConnectionStatus"),
// @ts-expect-error: Type mismatch between LoginSchema and userLogin expected types
async (arg, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.getConnectionStatus();
		if (response) {
			const {httpStatusCode, data, message} = response;
			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							   data:{
								data: data.data,
								message,
							   }
							}
						
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



export const checkWholesalerConnectionStatus = createAsyncThunk<
iGenericResponse<any | null> | null,
{wholesalerId:string},
{
	rejectValue: iStateMessage;
}
>(
curriedGetThunkName("checkWholesalerConnectionStatus"),
// @ts-expect-error: Type mismatch between expected types
async ({wholesalerId}, {rejectWithValue}) => {
	try {
		const response = await wholesalerService.checkWholesalerConnectionStatus(wholesalerId);
		if (response) {
			const {httpStatusCode, data, message} = response;

			switch (httpStatusCode) {
				case httpStatusCodes.SUCCESS_OK: {
					if (data && data.data) {
						return {
							data: {
								data: data.data,
								message,
							}
						};
					} else {
						return rejectWithValue({
							httpStatusCode,
							message,
						});
					}
				}
				default: {
					return rejectWithValue({
						httpStatusCode,
						message,
					});
				}
			}
		} else {
			return rejectWithValue({
				message: "No response received",
			});
		}
	} catch (error) {
		return rejectWithValue({
			message: "Something went wrong",
		});
	}
},
);



